import React from 'react';
export const MENU_OPTION_TYPE_MENU = 'menu';
export const MENU_OPTION_TYPE_FOLDER = 'folder';
export const MENU_OPTION_TYPE_SUB_FOLDER = 'subFolder';
export const MENU_OPTION_TYPE_DASHBOARD = 'dashboard';

export const MenuContext = React.createContext<any>(null);
